import React, { ReactElement, useRef, useState } from 'react'

import cx from 'classnames'

import { Button, Div } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import Card from 'components/Card'
import TooltipHoverPortal from 'components/TooltipHoverPortal'
import { isDateOutsideRange } from 'utils/formatDates'

import { QR_TOOLTIP_STORE_NAME } from './constants'

import styles from './styles.module.css'

interface MobileTooltipQRProps {
  children: ReactElement | ReactElement[]
  className?: string
}

interface TooltipContentProps {
  onClose: () => void
  isVisible: boolean
}

const TooltipContent = ({ onClose, isVisible }: TooltipContentProps) => {
  return (
    <Card className={isVisible ? styles.TooltipCard : styles.HiddenCard}>
      <Div className={styles.LeftArrow} />
      <Div className={styles.CloseIcon} onClick={onClose}>
        <Icon name="close" width={12} height={12} />
      </Div>

      <Div className={styles.TooltipColumns}>
        <Div className={styles.TooltipText}>
          <Div className={styles.Title}>
            Take the Drift experience on the road
            <span role="img" aria-label="iphone">
              📱
            </span>
          </Div>
          <Div className={styles.Body}>
            Download Drift Mobile to get actionable insights and communication tools to help you
            prioritize, engage, and keep deal momentum going — all in the palm of your hand.
          </Div>
          <Button onClick={onClose} className={styles.CloseButton} type="tertiary">
            Close
          </Button>
        </Div>

        <img
          className={styles.TooltipImg}
          alt=""
          src={'https://s3.amazonaws.com/driftt-email-assets/MobileQR.png'}
          loading="lazy"
        />
      </Div>
    </Card>
  )
}

const MobileTooltipQR = ({ children, className }: MobileTooltipQRProps): ReactElement | any => {
  const [isOpen, setIsOpen] = useState(true)
  const toolTipRef = useRef(null)
  const otherTooltipVisible = document.getElementById('eduTooltip')

  const onClose = () => {
    localStorage.setItem(
      QR_TOOLTIP_STORE_NAME,
      JSON.stringify({
        lastSeen: new Date().getTime(),
        timesSeen: timesSeen + 1,
        pageSeen: 'ACTIVITY_FEED'
      })
    )
    setIsOpen(false)
  }

  const tooltipData = localStorage.getItem(QR_TOOLTIP_STORE_NAME)
  const { timesSeen, lastSeen } = tooltipData
    ? JSON.parse(tooltipData)
    : { lastSeen: null, timesSeen: 0 }

  const hasTooltip = timesSeen ? isDateOutsideRange(lastSeen, timesSeen > 3 ? 3 : 1) : true

  if (!hasTooltip || !isOpen) return children

  return (
    <TooltipHoverPortal
      isAlwaysOpen={true}
      className={cx(styles.TooltipContainer, className)}
      boundaryRef={toolTipRef.current}
      refElement={toolTipRef.current}
      placement="right"
      tooltipBody={<TooltipContent isVisible={!otherTooltipVisible} onClose={onClose} />}>
      <span className={styles.TooltipContentContainer} ref={toolTipRef}>
        {children}
      </span>
    </TooltipHoverPortal>
  )
}

export default MobileTooltipQR
